<template>
  <v-card elevation="0">
    <v-autocomplete
      :items="sortedList"
      v-model="localServiceAreaId"
      @change="updateServiceArea"
      item-text="displayName"
      item-value="id"
      label="Service Area"
      outlined
      placeholder="Select a Service Area..."
      hint="Inactive Service Areas appear at the bottom of the list"
      persistent-hint
      :clearable="false"
      :auto-select-first="false"
    >
      <template v-slot:item="{ item }">
        <span :class="{ 'grey--text text--darken-1 font-italic': item.active === 0 }">
          {{ item.displayName }}
        </span>
      </template>
    </v-autocomplete>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ServiceAreaSelector",
  computed: {
    ...mapState({
      list: state => state.admin.serviceArea.list,
    }),
    sortedList() {
      const active = this.list.filter(item => item.active !== 0);
      const inactive = this.list.filter(item => item.active === 0);

      const sortedActive = active
        .map(item => ({ ...item, displayName: `${item.name} (${item.id})` }))
        .sort((a, b) => a.displayName.localeCompare(b.displayName));

      const sortedInactive = inactive
        .map(item => ({ ...item, displayName: `${item.name} (${item.id}) (Inactive)` }))
        .sort((a, b) => a.displayName.localeCompare(b.displayName));

      return [...sortedActive, ...sortedInactive];
    },
  },
  created() {
    this.$store.dispatch("admin/serviceArea/fetchList", { includeInactive: true });

    // Initialize local state from route query param
    const queryServiceArea = this.$route.query.serviceArea;
    if (queryServiceArea) {
      const serviceAreaId = parseInt(queryServiceArea, 10);
      if (!isNaN(serviceAreaId)) {
        this.localServiceAreaId = serviceAreaId;
      }
    }
  },
  data() {
    return {
      localServiceAreaId: null,
    };
  },
  methods: {
    updateServiceArea(value) {
      // Validate the value before updating the route
      if (!value || typeof value !== "number" || isNaN(value)) {
        console.warn("Invalid service area value:", value);
        return;
      }

      // Only update route if the value actually changed
      const currentServiceAreaId = parseInt(this.$route.query.serviceArea, 10);
      if (currentServiceAreaId !== value) {
        this.$router.push({ query: { serviceArea: value } });
      }
    },
  },
  watch: {
    "$route.query.serviceArea": {
      handler(newValue) {
        if (newValue) {
          const serviceAreaId = parseInt(newValue, 10);
          if (!isNaN(serviceAreaId) && this.localServiceAreaId !== serviceAreaId) {
            this.localServiceAreaId = serviceAreaId;
          }
        } else {
          this.localServiceAreaId = null;
        }
      },
    },
  },
};
</script>
